console.log('SCRIPT IS RUNNING');

function injectBestSeller() {
  const target = document.querySelector('[data-rid="05829b47-d825-418c-a4ff-0a808af396ce"]');
  if (target) {
    if (target.querySelector('.best-seller-badge')) return;
    const span = document.createElement('span');
    span.className = 'best-seller-badge';
    span.textContent = 'Best Seller';
    target.appendChild(span);
  }
}

const observer = new MutationObserver(function () {
  injectBestSeller();
});

setTimeout(function () {
  injectBestSeller();

  const target = document.querySelector('[data-rid="05829b47-d825-418c-a4ff-0a808af396ce"]');
  if (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }
}, 1000);